export default __webpack_public_path__ + "static/media/frontpage_image.ec2974e8.png";